"use strict";

exports.__esModule = true;
exports["default"] = void 0;

require("core-js/modules/es6.array.index-of");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.object.assign");

var _classnames = _interopRequireDefault(require("classnames"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var SavingsLined = function SavingsLined(_ref) {
  var className = _ref.className,
      style = _ref.style,
      otherProps = _objectWithoutPropertiesLoose(_ref, ["className", "style"]);

  var styleProp = Object.assign({
    verticalAlign: 'middle'
  }, style);
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    className: (0, _classnames["default"])(className),
    viewBox: "0 0 24 24",
    style: styleProp
  }, otherProps), /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M22.5 13h-.524a6.3 6.3 0 00-5.537-5.927A4.383 4.383 0 0016.5 6.5a4.5 4.5 0 00-9 0 4.408 4.408 0 00.053.5H3.5a.5.5 0 00-.347.861L4.86 9.5A15.558 15.558 0 003.254 13H1.5a.5.5 0 00-.5.5v2a.5.5 0 00.084.277A11.855 11.855 0 006 19.85v1.65a.5.5 0 00.5.5H8a.5.5 0 00.354-.147L10.207 20H15v1.5a.5.5 0 00.5.5H17a.5.5 0 00.277-.084c.186-.125 4.418-3.016 4.7-7.917h.523a.5.5 0 000-1zM12 3a3.488 3.488 0 012.431 6H9.568A3.489 3.489 0 0112 3zm4.84 18H16v-1.5a.5.5 0 00-.5-.5H10a.5.5 0 00-.354.146L7.793 21H7v-1.5a.5.5 0 00-.342-.475A10.651 10.651 0 012 15.342V14h1.625a.5.5 0 00.482-.367 14.451 14.451 0 011.811-3.907.5.5 0 00-.061-.651L4.74 8h3.042a4.5 4.5 0 00.494 1H8a.5.5 0 000 1h8a.5.5 0 000-1h-.276a4.442 4.442 0 00.477-.949A5.281 5.281 0 0121 13.5c0 4.222-3.471 6.992-4.16 7.5zM8 11a1 1 0 101 1 1 1 0 00-1-1zm3.5-3.5v-2a.5.5 0 111 0v2a.5.5 0 01-1 0z",
    fill: "currentColor"
  })));
};

var _default = SavingsLined;
exports["default"] = _default;